export default __webpack_public_path__ + "static/media/hr-letters-custom-templates.06a68780.svg";